<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
         <h3 class="p-2">
            <small class="text-muted">Report Daily Mutation</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
              <div class="form-group col-3">
                <label for="subject">Start Date</label>
                <flat-pickr class="form-control" v-model="reportDailyMutation.startDate" ></flat-pickr>
              </div>
              <div class="form-group col-3">
                <label for="subject">To Date</label>
                <flat-pickr class="form-control" v-model="reportDailyMutation.toDate"></flat-pickr>
              </div>
             <div class="form-group col-6">
              <label for="uom">Product</label>
              <app-lookup-field :model="reportDailyMutation" :element="productLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
            </div>
        </div>
        <br /><br />
        <button type="button" class="btn btn-outline-success" @click="print">Print <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-danger" @click="cancel" style="margin-left: 20px;">Cancel <i class="far fa-window-close"></i></button>
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { reportDailyMutation } from '../../models/report'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppNavBar from '../../components/AppNavbar.vue'
import download from 'js-file-download';

export default {
    components: {
      AppLookupField, AppDatePicker, AppNavBar
    },
    data() {
      return {
        reportDailyMutation: {...reportDailyMutation},
        productLookup: {
            id: 'product-lookup',
            title: 'Product',
            type: 'form',
            apiUrl: 'product-list',
            filter: ['name'],
            fields: [
                {
                    placeholder: 'Name',
                    width: 6,
                    column: 'productName'
                },
            ],
            dtElements: [
                {
                title: 'Name',
                column: 'name'
                },
            ],
            affectedField: [
            {
                from: 'id',
                to: 'productId'
            },
            {
                from: 'name',
                to: 'productName'
            }
            ]
        },
      }
    },
    async created() {

    },
    methods: {
      async print() {
      const rptApi = api('print/report-daily-mutation')
      const query = { 
        params: {
          startDate: this.reportDailyMutation.startDate,
          toDate: this.reportDailyMutation.toDate,
          productId: this.reportDailyMutation.productId
        }
      }
      const excelFile = await rptApi.getFileWithQuery(query)
      download(excelFile, 'Report-Daily-Mutation.xlsx')
    },
    cancel() {
      this.$router.go(-1)
    },
    finishLookup(data) {
      const currentDailyMutation = this.reportDailyMutation
      this.reportDailyMutation = {
          ...currentDailyMutation,
          ...data
      }
    },
    finishUpload(data) {
      const currentDailyMutation = this.reportDailyMutation
      this.reportDailyMutation = {
        ...currentDailyMutation,
        ...data
      }
    },
    }
}
</script>